import React from 'react';
import { Save, X, AlertCircle } from 'lucide-react';
import './StickySaveBar.css';

const StickySaveBar = ({ onSave, onCancel, isSaving, error }) => {
  return (
    <div className="sticky-save-bar">
      {error ? (
        <div className="sticky-save-bar-error" role="alert">
          <AlertCircle size={18} />
          <span>{error}</span>
        </div>
      ) : null}
      <div className="save-bar-content">
        <div className="save-bar-left">
          <AlertCircle size={20} />
          <span>У вас есть несохраненные изменения</span>
        </div>
        <div className="save-bar-right">
          <button
            className="cancel-btn"
            onClick={onCancel}
            disabled={isSaving}
          >
            <X size={16} />
            Отменить
          </button>
          <button
            className="save-btn"
            onClick={onSave}
            disabled={isSaving}
          >
            <Save size={16} />
            {isSaving ? 'Сохранение...' : 'Сохранить изменения'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickySaveBar;
